export default {
	section_banner: {
		title: {
			one: '暗号資産',
		},
		main_title: {
			one: '販売',
		},
		paragraph: {
			one: '暗号資産の売却は難しいですか？まだ買い手を待っていますか？JPWorldPayなら、もう待つ必要はありません。当社のプラットフォームは市場と瞬時に接続し、必要なときにいつでも迅速かつ簡単に資産を換金できます。',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},

	credit_system: {
		title: '売りやすい',
		main_title: {
			one: '販売',
			two: '暗号通貨',
			three: 'ただ',
			four: 'より簡単になりました',
		},
		paragraph: {
			one: '顧客間販売 – 顧客はJPWorldPayに直接販売できます。直接出品や即時販売など、ご希望の方法で販売できます。',
			two: 'JPWorldPay は、ユーザーに柔軟なオプションを提供し、デジタル資産を自分の条件に合わせて簡単に価値に変えられるようにします。安全で便利、そしてユーザー主導の販売体験をお楽しみください。',
		},
		cta_buttons: {
			one: '始めましょう',
		},
	},

	charging_sec: {
		title: 'ボタンを1回クリックするだけで',
		sub_title: {
			one: 'の',
			two: '為替レート',
			three: '自動的に適用されます',
		},
		paragraph: {
			one: 'ボタンをワンクリックするだけで、現在の価格が自動的に適用されるので、すぐに販売できます。この即時価格設定機能により、スピードと正確性が確保され、手動での価格更新や遅延の手間が省けます。',
			two: '急いでいる場合でも、単に効率を重視する場合でも、JPWorldPay を使用すると、暗号資産をシームレスかつストレスなく売却できます。',
		},
		cta_buttons: {
			one: '今すぐ交換',
		},
	},

	section_newsletter: {
		label: 'ニュースレターを購読する',
		title: {
			one: '購読する',
			two: '最新情報を入手',
		},
		description: {
			one: '購読して、オファーや最新情報をメールボックスに直接受け取りましょう。',
			two: '当社の JPWorldPay ソリューションが貴社のビジネスをどのように拡大できるかについて詳しくは、お問い合わせください。',
		},
		form: {
			placeholder: 'メールID',
			button: '今すぐ購読する',
		},
	},
};
